import React, { useRef, useEffect, useState } from 'react';

const airlines = [
  { name: 'Royal Air Maroc',     logo: '/airlines/royal-air-maroc.png',     color: '#C41E3A' },
  { name: 'Brussels Airlines',   logo: '/airlines/brussels-airlines.jpg',   color: '#003399' },
  { name: 'Air France',          logo: '/airlines/air-france.jpg',          color: '#002157' },
  { name: 'TAP Portugal',        logo: '/airlines/tap-portugal.png',        color: '#C41E3A' },
  { name: 'Cabo Verde Airlines', logo: '/airlines/cabo-verde.png',          color: '#005B99' },
  { name: 'Vueling',             logo: '/airlines/vueling.png',             color: '#FFD700' },
  { name: 'Kenya Airways',       logo: '/airlines/kenya-airways.jpg',       color: '#C41E3A' },
  { name: 'Air Burkina',         logo: '/airlines/air-burkina.png',         color: '#009A44' },
  { name: 'Asky Airlines',       logo: '/airlines/asky-airlines.png',       color: '#8B4513' },
  { name: 'Air Peace',           logo: '/airlines/air-peace.png',           color: '#003580' },
  { name: 'Ethiopian Airlines',  logo: '/airlines/ethiopian-airlines.png',  color: '#009A44' },
  { name: 'Air Senegal',         logo: '/airlines/air-senegal.jpeg',         color: '#009A44' },
  { name: 'Transair',            logo: '/airlines/transair.png',            color: '#003580' },
  { name: 'Binter',              logo: '/airlines/binter.png',              color: '#009A44' },
  { name: "Air Côte d'Ivoire",   logo: '/airlines/air-cote-divoire.jpeg',    color: '#F47920' },
  { name: 'Mauritania Airlines', logo: '/airlines/mauritania-airlines.jpg', color: '#006233' },
  { name: "Emirates",   logo: '/airlines/emi.png',    color: '#F47920' },
  { name: "Qantas",   logo: '/airlines/qantas.png',    color: '#F47920' },
  { name: "South African Airways",   logo: '/airlines/sa.png',    color: '#F47920' },
  { name: "Turkish Airlines",   logo: '/airlines/ta.png',    color: '#F47920' },
  { name: "Canadian Airlines",   logo: '/airlines/ca.jpg',    color: '#F47920' },
  { name: "Equa Flight",   logo: '/airlines/ef.jpeg',    color: '#F47920' },
  { name: "TUI",   logo: '/airlines/tui.png',    color: '#F47920' },
  { name: "British Airways",   logo: '/airlines/ba.jpg',    color: '#F47920' },
  { name: "Trans Air Congo",   logo: '/airlines/tac.jpg',    color: '#F47920' },
  { name: "Afrijet",   logo: '/airlines/afrijet.png',    color: '#F47920' },
  { name: "KLM",   logo: '/airlines/klm.jpg',    color: '#F47920' },
  { name: "Gulf Air",   logo: '/airlines/ga.png',    color: '#F47920' },
  { name: "MEA",   logo: '/airlines/mea.png',    color: '#F47920' },
  { name: "Tunisair",   logo: '/airlines/ts.png',    color: '#F47920' },
  { name: "Lufthansa",   logo: '/airlines/luf.png',    color: '#F47920' },
  { name: "Latam Airlines",   logo: '/airlines/lat.png',    color: '#F47920' },
  { name: "Qatar Airways",   logo: '/airlines/qa.png',    color: '#F47920' },
  { name: "Egyptair",   logo: '/airlines/egy.jpg',    color: '#F47920' },
  { name: "Japan Airlines",   logo: '/airlines/jal.png',    color: '#F47920' },
  { name: "Australian Airlines",   logo: '/airlines/aus.png',    color: '#F47920' },
  { name: "Transvia",   logo: '/airlines/trans.png',    color: '#F47920' },
  { name: "ITA Airways",   logo: '/airlines/ita.png',    color: '#F47920' },
  { name: "Cathy Pacific",   logo: '/airlines/cat.png',    color: '#F47920' },
  { name: "Singapore Airlines",   logo: '/airlines/singa.png',    color: '#F47920' },
  { name: "IndiGo",   logo: '/airlines/indigo.png',    color: '#F47920' },
];

const clients = [
  { name: 'WHO',                                logo: '/clients/who.png' },
  { name: 'Huawei',                             logo: '/clients/huawei.png' },
  { name: 'Cooperazione Internazionale',        logo: '/clients/cooperazione-internazionale.png' },
  { name: 'PRCM',                               logo: '/clients/prcm.png' },
  { name: 'CEDIM',                              logo: '/clients/cedim.jpeg' },
  { name: 'Bundesrepublik Deutschland',         logo: '/clients/bundesrepublik-deutschland-botschaft.png' },
  { name: 'Bank aus Verantwortung',             logo: '/clients/bank-aus-verantwortung.png' },
  { name: 'Peace Corps',                        logo: '/clients/peace-corps.png' },
  { name: 'Friedrich-Ebert-Stiftung',           logo: '/clients/friedrich-ebert-stiftung.png' },
  { name: 'VSO',                                logo: '/clients/vso.png' },
  { name: 'Afrique Verte International',        logo: '/clients/afrique-verte-international.jpg' },
  { name: 'Cuso International',                 logo: '/clients/cuso-international.jpeg' },
  { name: 'British American Tobacco',           logo: '/clients/british-american-tobacco.png' },
  { name: 'IMF',                                logo: '/clients/imf.png' },
  { name: 'Camtel',                             logo: '/clients/camtel.png' },
  { name: 'Amnesty International',              logo: '/clients/amnesty-international.jpg' },
  { name: 'IRD France',                         logo: '/clients/ird-france.png' },
  { name: 'Comete International',               logo: '/clients/comete-international.png' },
  { name: 'Bivac Armenia',                      logo: '/clients/bivac-armenia.jpg' },
  { name: 'Unite Travail Progres',              logo: '/clients/unite-travail-progres.png' },
  { name: 'Bareme des Redevances',              logo: '/clients/bareme-des-redevances.jpeg' },
  { name: 'WWF',                                logo: '/clients/wwf.png' },
  { name: 'SOS Sahel International',            logo: '/clients/sos-sahel-international.png' },
  { name: 'FDC',                                logo: '/clients/fdc.jpg' },
  { name: 'Plan International',                 logo: '/clients/plan-international.png' },
  { name: 'Aide et Action',                     logo: '/clients/aide-et-action.png' },
  { name: 'SIGRI',                              logo: '/clients/sigri.jpeg' },
  { name: 'Comité International Genève',        logo: '/clients/comite-international-geneve.png' },
  { name: 'CERDI',                              logo: '/clients/cerdi.png' },
  { name: 'CAMTS',                              logo: '/clients/camts.jpg' },
  { name: 'DFID',                               logo: '/clients/dfid.jpg' },
  { name: 'Embassy of Japan',                   logo: '/clients/embassy-of-japan.jpeg' },
  { name: 'CREPA',                              logo: '/clients/crepa.png' }
];

const doubledAirlines = [...airlines, ...airlines];
const doubledClients  = [...clients,  ...clients];

function AirlineCard({ item }) {
  const [imgFailed, setImgFailed] = useState(false);
  return (
    <div style={{
      flexShrink: 0, width: 180, height: 90,
      background: '#fff', borderRadius: 12,
      boxShadow: '0 2px 12px rgba(17,45,78,0.08)',
      border: '1px solid rgba(17,45,78,0.07)',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      gap: 8, padding: '10px 16px', userSelect: 'none'
    }}>
      {!imgFailed ? (
        <img
          src={item.logo}
          alt={item.name}
          onError={function() { setImgFailed(true); }}
          style={{ height: 36, width: 'auto', maxWidth: 130, objectFit: 'contain', display: 'block' }}
        />
      ) : (
        <div style={{
          width: 40, height: 28, borderRadius: 6,
          background: (item.color || '#3F72AF') + '15',
          border: '1.5px solid ' + (item.color || '#3F72AF') + '40',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: '0.6rem', fontWeight: 900,
          color: item.color || '#3F72AF', letterSpacing: '0.04em'
        }}>
          {item.name.split(' ').map(function(w) { return w[0]; }).join('').slice(0, 4)}
        </div>
      )}
      <p style={{
        margin: 0, fontSize: '0.72rem', fontWeight: 600,
        color: 'var(--bj-espresso)', textAlign: 'center',
        lineHeight: 1.3, opacity: 0.75
      }}>
        {item.name}
      </p>
    </div>
  );
}

function ClientCard({ item }) {
  const [imgFailed, setImgFailed] = useState(false);
  return (
    <div style={{
      flexShrink: 0, width: 190, height: 90,
      background: '#fff', borderRadius: 12,
      boxShadow: '0 2px 12px rgba(17,45,78,0.08)',
      border: '1px solid rgba(17,45,78,0.07)',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      gap: 8, padding: '10px 18px', userSelect: 'none'
    }}>
      {!imgFailed ? (
        <img
          src={item.logo}
          alt={item.name}
          onError={function() { setImgFailed(true); }}
          style={{ height: 38, width: 'auto', maxWidth: 140, objectFit: 'contain', display: 'block' }}
        />
      ) : (
        <div style={{
          padding: '4px 10px', borderRadius: 6,
          background: 'var(--bj-sand)',
          fontSize: '0.68rem', fontWeight: 800,
          color: 'var(--bj-espresso)', letterSpacing: '0.04em',
          textAlign: 'center'
        }}>
          {item.name.split(' ').map(function(w) { return w[0]; }).join('').slice(0, 5)}
        </div>
      )}
      <p style={{
        margin: 0, fontSize: '0.7rem', fontWeight: 600,
        color: 'var(--bj-espresso)', textAlign: 'center',
        lineHeight: 1.3, opacity: 0.7
      }}>
        {item.name}
      </p>
    </div>
  );
}

function MoreCard() {
  return (
    <div style={{
      flexShrink: 0, width: 180, height: 90,
      background: 'linear-gradient(135deg, var(--bj-clay), #2d5a8e)',
      borderRadius: 12,
      boxShadow: '0 2px 12px rgba(63,114,175,0.25)',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      gap: 2, userSelect: 'none'
    }}>
      <p style={{ margin: 0, fontSize: '1.4rem', fontWeight: 800, color: '#fff', lineHeight: 1 }}>100+</p>
      <p style={{ margin: 0, fontSize: '0.72rem', fontWeight: 600, color: 'rgba(255,255,255,0.8)', textAlign: 'center', lineHeight: 1.4 }}>
        More Airlines<br />Globally
      </p>
    </div>
  );
}

function MarqueeRow({ items, direction, renderItem, pauseRef }) {
  const trackRef = useRef(null);
  const rafRef   = useRef(null);
  const posRef   = useRef(0);
  const SPEED    = 0.45;

  useEffect(function() {
    var el = trackRef.current;
    if (!el) return;

    var halfWidth = el.scrollWidth / 2;

    // Stagger start for right-moving row
    if (direction === 'right') {
      posRef.current = -(halfWidth / 2);
    }

    function tick() {
      if (!pauseRef.current) {
        if (direction === 'left') {
          posRef.current -= SPEED;
          if (Math.abs(posRef.current) >= halfWidth) posRef.current = 0;
        } else {
          posRef.current += SPEED;
          if (posRef.current >= 0) posRef.current = -halfWidth;
        }
        el.style.transform = 'translateX(' + posRef.current + 'px)';
      }
      rafRef.current = requestAnimationFrame(tick);
    }

    rafRef.current = requestAnimationFrame(tick);
    return function() { cancelAnimationFrame(rafRef.current); };
  }, [direction, pauseRef]);

  return (
    <div ref={trackRef} style={{ display: 'flex', gap: 16, width: 'max-content', paddingLeft: 16 }}>
      {items.map(function(item, i) { return renderItem(item, i); })}
    </div>
  );
}

export default function PartnersSection() {
  const paused1 = useRef(false);
  const paused2 = useRef(false);

  return (
    <section style={{ background: 'var(--bj-cream-soft)', padding: '72px 0', overflow: 'hidden' }}>

      {/* Header */}
      <div className="container" style={{ textAlign: 'center', marginBottom: 48 }}>
        <span className="eyebrow">Our Network</span>
        <h2 style={{ margin: '10px 0 12px' }}>Partners &amp; Clients</h2>
        <p style={{ opacity: 0.65, maxWidth: 520, margin: '0 auto', fontSize: '0.95rem', lineHeight: 1.7 }}>
          Trusted by leading international organisations, NGOs, embassies, and corporations
          across West Africa and South Asia for their travel needs.
        </p>
      </div>

      {/* Divider label — Airlines */}
      <div className="container" style={{ marginBottom: 14 }}>
        <span style={{
          fontSize: '0.7rem', fontWeight: 700, letterSpacing: '0.12em',
          textTransform: 'uppercase', opacity: 0.4
        }}>
          Partnered Airlines
        </span>
      </div>

      {/* Row 1 — Airlines, scroll left */}
      <div
        style={{ overflow: 'hidden', marginBottom: 28 }}
        onMouseEnter={function() { paused1.current = true; }}
        onMouseLeave={function() { paused1.current = false; }}
      >
        <MarqueeRow
          items={doubledAirlines}
          direction="left"
          pauseRef={paused1}
          renderItem={function(item, i) {
            return (
              <AirlineCard key={item.name + i} item={item} />
            );
          }}
        />
      </div>

      {/* Thin divider */}
      <div style={{ height: 1, background: 'var(--bj-sand)', maxWidth: 1180, margin: '0 auto 28px' }} />

      {/* Divider label — Clients */}
      <div className="container" style={{ marginBottom: 14 }}>
        <span style={{
          fontSize: '0.7rem', fontWeight: 700, letterSpacing: '0.12em',
          textTransform: 'uppercase', opacity: 0.4
        }}>
          Our Clients
        </span>
      </div>

      {/* Row 2 — Clients, scroll right */}
      <div
        style={{ overflow: 'hidden' }}
        onMouseEnter={function() { paused2.current = true; }}
        onMouseLeave={function() { paused2.current = false; }}
      >
        <MarqueeRow
          items={doubledClients}
          direction="right"
          pauseRef={paused2}
          renderItem={function(item, i) {
            return (
              <ClientCard key={item.name + i} item={item} />
            );
          }}
        />
      </div>

      {/* Footer note */}
      <div className="container" style={{ textAlign: 'center', marginTop: 36 }}>
        <p style={{ opacity: 0.4, fontSize: '0.78rem', margin: 0 }}>
          Hover to pause · Logos are property of their respective organisations
        </p>
      </div>
    </section>
  );
}